import * as React from 'react';

import ProjectorHeader from './projectorHeader';

import {
  Feedback,
  SentenceFragments,
  Cues,
} from '../../../../Shared/index';
import {
  QuestionData
} from '../../../interfaces/classroomLessons';
import { textEditorInputNotEmpty } from '../shared/textEditorClean';
const teacherPointingSrc = `${window.postbuildEnv.CDN_URL}/images/icons/teacher-pointing.svg`

interface ModelQuestionProps {
  data: QuestionData,
  model?: string|null,
  prompt?: string|null,
  projector?: boolean
}

interface ModelQuestionState {}

class ModelQuestion extends React.Component<ModelQuestionProps, ModelQuestionState> {
  renderInstructions() {
    const { data, } = this.props

    if (!data.play.instructions) { return }

    return (
      <Feedback
        feedbackHtml={data.play.instructions}
        feedbackType="default"
      />
    );
  }

  renderCues() {
    const { data, } = this.props
    if (!data.play.cues) { return }
    return (
      <Cues
        displayArrowAndText={false}
        question={data.play}
      />
    );
  }

  renderTeacherModel() {
    const { model, } = this.props
    return (
      <div className="display-mode">
        <p className="answer-header">
          Teacher&#39;s response
        </p>
        <p className="teacher-model" dangerouslySetInnerHTML={{__html: model}} />
      </div>
    )
  }

  renderQuestionOrHTML() {
    const { data, prompt, } = this.props
    if (!data.play.prompt) { return }
    const editedPrompt = prompt;
    const promptNotEmpty = textEditorInputNotEmpty(editedPrompt);
    const promptToShow = promptNotEmpty ? editedPrompt : data.play.prompt;
    return (
      <div className="question-content">
        <SentenceFragments prompt={promptToShow} />
        {this.renderCues()}
        {this.renderInstructions()}
      </div>
    )
  }

  renderProjectorFooter() {
    const { projector, } = this.props
    if (!projector) { return }
    return <ProjectorHeader label="Students watch teacher" />
  }

  renderWatchTeacherFooter() {
    const { projector, } = this.props

    if (projector) { return }

    return (
      <div className="watch-teacher-footer">
        <img alt="Teacher pointing to a chalkboard icon" src={teacherPointingSrc} />
        <p><strong>Watch your teacher.</strong> No need to type a response this time.</p>
      </div>
    )
  }


  render() {
    return (
      <div className="student-model-wrapper student-slide-wrapper">
        <div className="all-but-submitted-bar">
          {this.renderQuestionOrHTML()}
          {this.renderTeacherModel()}
          {this.renderWatchTeacherFooter()}
        </div>
        {this.renderProjectorFooter()}
      </div>
    );
  }
}

export default ModelQuestion;
